(function() {
  'use strict';

  angular.module('eclipseApp.checkout').controller('buyCtrl', [
    '$scope',
    '$state',
    '$rootScope',
    'buyService',
    '$modal',
    '$stateParams',
    'notifier',
    'cartManager',
    'uteModal',
    'commonService',
    'buyUtils',
    '$timeout',
    '$window',
    'uteLocale',
    'env',
    '$log',
    'brtSwitchCMS',
    function(
      $scope,
      $state,
      $rootScope,
      buyService,
      $modal,
      $stateParams,
      notifier,
      cartManager,
      uteModal,
      commonService,
      buyUtils,
      $timeout,
      $window,
      uteLocale,
      env,
      $log,
      brtSwitchCMS
    ) {
      // set defaults for each form if there's nothing in session storage for this
      var _self = {};
      var sessionStoredData = buyService.getSession('profile');
      var sessionStoredAddress = buyService.getSession('serviceable');

      $scope.canCancel = function() {
        if ($rootScope.ruiMethods.user.is.agent()) {
          if (brtSwitchCMS.brtSwitch.isHybridFlow === true) {
            return false;
          }
          return true;
        }
        return true;
      };

      $scope.isHybridFlow = brtSwitchCMS.brtSwitch.isHybridFlow;

      var isAgentAndIsHybridFlow = $rootScope.ruiMethods.user.is.agent() && $scope.isHybridFlow;

      _self.lang = buyUtils.getAppLang();

      // flag to check to allow transitioning to another state from checkout
      _self.forceTransition = false;

      $scope.checkoutContext = buyService.getCartContext();

      $scope.serviceAddress = {
        label: '',
        cableCondition: buyService.getCableCondition(),
        address: {}
      };

      _self.hsiCheckout = {
        createUser: {
          __completed: false,
          billingAddress:
            ($rootScope.ruiMethods.agent.has.customerContext() && $rootScope.ruiMethods.user.is.agent()) ||
            $rootScope.ruiMethods.user.is.loggedIn()
              ? 'existingBillingAddress'
              : 'serviceAddress',
          language: _self.lang,
          phoneType: 1,
          address: '', // tbd: remove
          allowEditEmail: false,
          data: {
            anotherBillingAddress: {},
            serviceAddress: '',
            existingBillingAddress: ''
          }
        },
        creditCheck: {
          __completed: false,
          riskClassFlag: false, // true: use to prevent from procceeding
          riskClassName: '',
          rcCode: null,
          riskClassRedirect: false,
          allowPAC: false,
          pending: null,
          visited: null,
          data: {}
        },
        fulfillment: {
          __completed: false,
          options: {
            shipToAddress: {
              shippingAddressOption: 'serviceAddress'
            },
            pickupAtStore: {},
            techInstall: {},
            takeItWithYou: {}
          },
          techInstallTouched: false,
          selectedOption: 'shipToAddress' // default selected tab
        },
        paymentOptions: {
          __completed: isAgentAndIsHybridFlow,
          billingMethod: 'online',
          selectedPaymentOption: isAgentAndIsHybridFlow ? 'invoice' : '', // invoice | formPac | formPacc
          submitted: isAgentAndIsHybridFlow,
          data: {
            invoice: isAgentAndIsHybridFlow
              ? {
                  paymentType: 'invoice',
                  receiveBill: 'Online',
                  sendBill: ''
                }
              : {},
            pac: {},
            pacc: {}
          } // put selected option data
        },
        review: {
          __completed: false,
          isTouched: false,
          data: {}
        },
        confirmation: {
          __completed: false,
          data: {}
        }
      };

      _self.tvCheckout = {
        createUser: {
          __completed: false,
          billingAddress: $rootScope.ruiMethods.user.is.loggedIn() ? 'existingBillingAddress' : 'serviceAddress',
          language: _self.lang,
          phoneType: 1,
          address: '', // tbd: remove
          allowEditEmail: false,
          data: {
            anotherBillingAddress: {},
            serviceAddress: '',
            existingBillingAddress: ''
          }
        },
        review: {
          __completed: false,
          isTouched: false,
          data: {}
        },
        confirmation: {
          __completed: false,
          data: {}
        }
      };

      $scope.forms = _.extend(_self.hsiCheckout, sessionStoredData);

      $scope.checkoutStepTabs = [
        {
          labelTag: 'global.label.profile',
          number: '1',
          route: 'createUser',
          isDisabled:
            !$scope.forms.createUser.__completed ||
            ($scope.forms.createUser.__completed && $scope.forms.review.__completed)
        },
        {
          labelTag: buyService.getCurrentUserType().isAgent ? 'retail.label.review' : 'global.label.review',
          number: '2',
          route: 'review',
          isDisabled:
            ($scope.forms.createUser.__completed && $scope.forms.review.__completed) ||
            !$scope.forms.createUser.__completed
        },
        {
          labelTag: 'global.label.confirmation',
          number: '3',
          route: 'confirmation',
          isDisabled:
            !$scope.forms.confirmation.__completed &&
            !$scope.forms.createUser.__completed &&
            !$scope.forms.review.__completed
        }
      ];

      buyService.getServiceAddressDetails().then(
        function(res) {
          // getting address from session for now
          if (res) {
            $scope.serviceAddress.label =
              (res.address.unitNumber ? res.address.unitNumber + '-' : '') +
              res.address.streetNumber +
              ' ' +
              res.address.streetName +
              ' ' +
              res.address.streetType +
              ' ' +
              res.address.city +
              ' ' +
              res.address.province +
              '  ' +
              res.address.postalCode;

            $scope.serviceAddress.address = res.address;

            // if there is a session that is not complete
            // set the address in the scope
            if (_.findKey($scope['forms'], { __completed: false })) {
              $scope.forms.createUser.address = $scope.forms.createUser.data.serviceAddress = res.address;
            }
          }
        },
        function(res) {
          // _self.forceTransition = true;
          // $state.go('internet');
          // $timeout(function(){
          //   _self.forceTransition = false;
          //   notifier.notify.info({
          //     title: 'Oops',
          //     desc: 'An issue occured while processing your service address. Please try again.'
          //   });
          // });
        }
      );

      if ($scope.forms && $scope.forms.createUser && $scope.forms.createUser.data) {
        $scope.forms.createUser.data.existingBillingAddress = '';
        if ($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) {
          if (commonService.customerHasWirelessService) {
            buyService.getExistingBillingAddressDetails(commonService.wirelessAccountNumber).then(
              function(res) {
                // if there is a session that is not complete
                // set the address in the scope
                console.log('getExistingBillingAddressDetails res', res);

                if (_.findKey($scope['forms'], { __completed: false })) {
                  $scope.forms.createUser.data.existingBillingAddress = {
                    // label: (res.data.address.unitNumber ? (res.data.address.unitNumber + '-') : "") + res.data.address.streetNumber + ' ' + res.data.address.streetName + ' ' + res.data.address.streetType + ' ' + res.data.address.city + ' ' + res.data.address.province + '  ' + res.data.address.postalCode,
                    label: '',
                    address: {
                      city: res.data.address.city,
                      province: res.data.address.province,
                      postalCode: res.data.address.postalCode,
                      country: 'Canada',
                      streetNumber: res.data.address.streetNumber,
                      streetName: res.data.address.streetName,
                      streetType: res.data.address.streetType,
                      unitNumber: res.data.address.unit,
                      streetDirection: res.data.address.streetDirection
                    }
                  };
                }
                buyService.saveSession('profile', $scope.forms);

                var emailRegx = /^((([a-zA-Z]|[0-9])|([-]|[_]|[.]))+[@](([a-zA-Z0-9])|([-])){2,63}[.](([a-zA-Z0-9]){2,63})+)$/i;
                if ($scope.forms && $scope.forms.creditCheck && !$scope.forms.creditCheck.visited) {
                  if (res.data.email && emailRegx.test(res.data.email)) {
                    $scope.forms.createUser.allowEditEmail = false;
                    $scope.forms.createUser.email_address = res.data.email;
                    $scope.forms.createUser.confirmEmail = res.data.email;
                  } else if ($rootScope.userInfo.userID && emailRegx.test($rootScope.userInfo.userID)) {
                    $scope.forms.createUser.allowEditEmail = false;
                    $scope.forms.createUser.email_address = $rootScope.userInfo.userID;
                    $scope.forms.createUser.confirmEmail = $rootScope.userInfo.userID;
                  } else {
                    $scope.forms.createUser.allowEditEmail = true;
                    $scope.forms.createUser.email_address = '';
                    $scope.forms.createUser.confirmEmail = '';
                  }
                }

                $scope.forms.createUser.firstName = res.data.firstName;
                $scope.forms.createUser.lastName = res.data.lastName;

                if (res.data.homePhone && res.data.homePhone.length === 10) {
                  $scope.forms.createUser.phone = res.data.homePhone;
                  $scope.forms.createUser.phoneType = 2;
                } else if (res.data.businessPhone && res.data.businessPhone.length === 10) {
                  $scope.forms.createUser.phone = res.data.businessPhone;
                  $scope.forms.createUser.phoneType = 3;
                } else if (res.data.mobilePhone && res.data.mobilePhone.length === 10) {
                  $scope.forms.createUser.phone = res.data.mobilePhone;
                  $scope.forms.createUser.phoneType = 1;
                } else {
                  $scope.forms.createUser.phone = null;
                }

                console.log(
                  '$scope.forms.createUser.data.existingBillingAddress',
                  $scope.forms.createUser.data.existingBillingAddress
                );
              },
              function(res) {}
            );
          } else {
            //if commonService.customerHasWirelessService
            angular.extend($scope.forms.createUser, {
              formEditable: true,
              billingAddress: 'serviceAddress'
            });
          }
        } // if loggedIn || agent
      } // if /ROOT

      // this is for the first time. the statechanges after this are handled by the ui-router providers
      route();

      // submit form -- save in sessionStorage, move to next step
      $scope.completedForm = function(formName, routeUser) {
        // console.log('@completedForm: (formName, routeUser) ', formName, routeUser);

        // if the user wishes to route to the next incomplete step
        routeUser = angular.isUndefined(routeUser) ? true : false;

        // remove formatting of phone number when storing
        if (formName === 'createUser' && $scope.forms.createUser.phone) {
          $scope.forms.createUser.phone = buyUtils.formatPhoneNumber($scope.forms.createUser.phone);
        }

        if (routeUser === true) {
          $scope.forms[formName].__completed = true;
          // console.log('@buy:SAVING SESSION ');
          buyService.saveSession('profile', $scope.forms);
          route();
        } else {
          buyService.saveSession('profile', $scope.forms);
        }
      };

      $scope.buyMethods = {
        navigateAwayFromCheckout: function(toState) {
          $state.go(toState);
        },
        editCheckout: function(to) {
          if (to === 'internet') {
            // console.log('@buy:editCheckout (to) ', to);
            buyService.setCheckoutMode(true);

            $state.go(to);
            // buyService.cancelCheckout().then(function(res){
            // }, function(res){
            //   notifier.notify.error();
            // });
          } else if (to === 'techInstall' || to === 'fulfillment') {
            buyService.setCheckoutMode(true);
            // console.log('@buy:buyMethods:editCheckout:ELSEIF:fulfillment||techInstall');
            // reset payment-options
            // buyService.resetStep('paymentOptions');
            // go to page
            $state.go(to);
          } else {
            buyService.setCheckoutMode(true);
            $state.go(to);
          }
        },
        initFormsScope: function() {
          $scope.forms = buyService.getSession('profile');
        }
      };

      // handle routes once you're in the buy flow
      $scope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {
        // var isAgentAndisHybridFlow = brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent();

        var modalInstance;

        if (
          $scope.forms &&
          $scope.forms.creditCheck &&
          $scope.forms.creditCheck.riskClassFlag &&
          !$scope.forms.creditCheck.__completed &&
          $scope.forms.creditCheck.riskClassRedirect
        ) {
          /*
           * @if
           * handle: request-indepth-eval redirect to home
           * skip cancel-step modal on riskclass fraud or isPacOnly
           */

          switch ($scope.forms.creditCheck.riskClassName) {
            case 'FRAUD':
            case 'CONDITIONAL_APPROVAL':
            case 'MANUAL_REVIEW':
            case 'NEGATIVE': // allow user when the request in-depth evaluation
              _self.forceTransition = true;
              break;
            default:
          }
        }

        // console.log('--$on.$stateChangeStart (session) ', buyService.getSession('profile'));
        // console.log('$on.$stateChangeStart (e)', e);
        // console.log('$on.$stateChangeStart (toState)', toState);
        // console.log('$on.$stateChangeStart (fromState)',fromState);
        // console.log('$on.$stateChangeStart (toParams)', toParams);
        // console.log('$on.$stateChangeStart (fromParams)',fromParams);
        // console.log('$on.$stateParams ',$stateParams);
        // console.log('--$on:forceTransition ', _self.forceTransition);

        if (
          (toState.name === 'home' || toState.name === 'cartSummary') &&
          !_self.forceTransition &&
          fromState.name !== 'confirmation'
        ) {
          // while in confirmation step
          // while no page refresh
          // when navigating to home or cart-summary page
          // don't show the cancel-step modal
          if ($scope.forms.confirmation.__completed && fromState.name === 'confirmation') {
            e.preventDefault();
            return;
          }

          /*
           * @if
           * handle: cancel and clicking fido logo
           *
           * @modalInstance resolve.data: Function
           *
           * @property isTechInstallTouched: Bool
           * case: isTechInstallTouched=true
           * if user had selected techInstall tab during checkout session
           *
           * @property toState: Object
           * $stateChangeStart event toState object to contain the state
           * the user will be navigating to.
           *
           * @method setForceTransition: Bool
           * method bind to cancel-step-modal to set _self.forceTransition value
           * to force transition to home or cart-summary page.
           *
           * @method getForceTransition: Bool
           * method that returns the value of _self.forceTransition
           * to be consumed by the cancel-step-modal controller.
           *
           *
           */

          if (!_self.forceTransition) {
            modalInstance = $modal.open({
              templateUrl: 'modules/checkout/views/cancel-step-modal.html',
              controller: 'CancelStepCtrl',
              scope: $scope,
              resolve: {
                data: function() {
                  return {
                    isTechInstallTouched: $scope.forms.fulfillment.techInstallTouched,
                    toState: toState,
                    setForceTransition: function(boolValue) {
                      _self.forceTransition = boolValue;
                    },
                    getForceTransition: function() {
                      return _self.forceTransition;
                    }
                  };
                }
              }
            });
          }

          if (modalInstance) {
            modalInstance.result.then(
              function(data) {
                if (_self.forceTransition) {
                  /*
                   * @if
                   * handle: user click continue on modal
                   *
                   * @param data
                   * the state to be redirected to
                   *
                   */

                  if (fromState.name !== 'createUser' || fromState.name !== 'creditCheck') {
                    /*
                     * @if
                     * set checkout mode = true
                     * but only if current state is not createUser or creditCheck
                     *
                     */
                    buyService.setCheckoutMode(true);
                  }

                  $state.go(data.name);
                  _self.forceTransition = false;
                }
              },
              function(res) {}
            );
          }

          e.preventDefault();
          return;
        } // ifROOT

        if (
          (buyService.getSession('profile') && toState.parent !== 'buy' && fromState.name === 'review') ||
          (buyService.getSession('profile') && toState.parent !== 'review' && fromState.parent === 'fulfillment')
        ) {
          /*
           * @if
           * handle: edit package from review
           */
          // console.log('EDIT PCKG');
          if (toState.name === 'internet') {
            // console.log('EDIT PCKG 1');

            if (!_self.forceTransition) {
              var editInternetPckgModalInstance = $modal.open({
                templateUrl: 'modules/checkout/views/cancel-step-modal.html',
                controller: 'CancelStepCtrl',
                scope: $scope,
                resolve: {
                  data: function() {
                    return {
                      isTechInstallTouched: $scope.forms.fulfillment.techInstallTouched,
                      toState: toState,
                      setForceTransition: function(boolValue) {
                        _self.forceTransition = boolValue;
                      },
                      getForceTransition: function() {
                        return _self.forceTransition;
                      }
                    };
                  }
                }
              });

              editInternetPckgModalInstance.result.then(
                function(resp) {
                  if (_self.forceTransition) {
                    $state.go(resp.name);
                    _self.forceTransition = false;
                  }
                },
                function(respErr) {
                  buyService.setCheckoutMode(false);
                  // console.log('CANCELED EDIT PACKAGE');
                }
              );

              e.preventDefault();
            } // if _self.forceTransition
          }
        }

        if (buyService.getSession('profile') && toState.parent !== 'buy' && fromState.name === 'confirmation') {
          /*
           * @if
           * When order is confirmed and navigating away from checkout flow
           * will delete all checkout session
           *
           */
          _.defer(function() {
            buyService.deleteCheckoutSession();
            $scope.$apply();
          });

          if (toState.parent === 'fulfillment') {
            switch (toState.name) {
              case 'shipToAddress':
              case 'pickupAtStore':
              case 'takeItWithYou':
              case 'techInstall':
                $window.location.replace(env.fidoHomePageUrl);
                e.preventDefault();
                break;
              default:
            }
          }
        } // if ROOT

        // if the future state is profile, route within profile instead
        if (toState.name === 'buy') {
          e.preventDefault();
          route();

          // if the future state is not profile and IS a child state of profile;
        } else if (toState.parent === 'buy') {
          // if ROOT
          // console.log('ONE ($scope)', $scope);
          var formsValid =
            angular.isDefined($scope.forms[toState.name]) && angular.isDefined($scope.forms[fromState.name]);

          // while in fulfillment step
          if (fromState.parent === 'fulfillment') {
            // once landed in fulfillment option step on a 3-tabbed case

            // navigating back to previous step will not happen, you wish!
            if (toState.name === 'fulfillment' && buyService.getFulfillmentType() > 1) {
              e.preventDefault();
            }

            // prevent going back to previous step: credit-check or create-profile
            if ($scope.forms[toState.name].__completed && !(fromState.name in $scope.forms)) {
              e.preventDefault();
            }

            if (!buyService.getSession('profile') && !buyService.getSession('fulfillment')) {
              e.preventDefault();
            }
          }

          if (toState.name === 'creditCheck' && fromState.name === 'review') {
            e.preventDefault();
          }

          if (toState.name === 'createUser' && fromState.name === 'review') {
            e.preventDefault();
          }

          // TODO conflict with navigating between createUser and creditCheck
          // while in review or payment-options step
          // if (toState.name in $scope.forms) {
          //   console.log('THREE');
          //   if (fromState.name !== 'creditCheck' || fromState.name !== 'createUser') {
          //     console.log('FOUR');
          //     // navigating back to either create-profile or credit-check will just be in your dreams!
          //     if ($scope.forms[toState.name].__completed && toState.name === 'createUser') e.preventDefault();
          //     if ($scope.forms[toState.name].__completed && toState.name === 'creditCheck') e.preventDefault();
          //   }

          // }

          // while in confirmation
          //going back to previous step is a no no
          if (
            fromState.name === 'confirmation' &&
            toState.name in $scope.forms &&
            !_.findKey(buyService.getSession('profile'), { __completed: false })
          ) {
            e.preventDefault();
          }
          if (
            fromState.name === 'confirmation' &&
            toState.parent === 'fulfillment' &&
            !_.findKey(buyService.getSession('profile'), { __completed: false })
          ) {
            e.preventDefault();
          }

          // if the current state form is not completed and the future state is not completed, prevent moving around
          if (formsValid && (!$scope.forms[toState.name].__completed && !$scope['forms'][fromState.name].__completed)) {
            // console.log('FIVE');
            {
              e.preventDefault();
            }
          }

          // handle going back from review
          if (fromState.name === 'review' && toState.parent === 'buy') {
            if (toState.name === 'paymentOptions' && $scope.forms[toState.name].__completed) {
              if (!_self.forceTransition && fromState.name === 'review') {
                var editTechInstallModalInstance = $modal.open({
                  templateUrl: 'modules/checkout/views/cancel-step-modal.html',
                  controller: 'CancelStepCtrl',
                  scope: $scope,
                  resolve: {
                    data: function() {
                      return {
                        isTechInstallTouched: $scope.forms.fulfillment.techInstallTouched,
                        toState: toState,
                        setForceTransition: function(boolValue) {
                          _self.forceTransition = boolValue;
                        },
                        getForceTransition: function() {
                          return _self.forceTransition;
                        }
                      };
                    }
                  }
                });

                editTechInstallModalInstance.result.then(
                  function(resp) {
                    if (_self.forceTransition) {
                      $state.go(resp.name);
                      _self.forceTransition = false;
                    }
                  },
                  function(respErr) {
                    buyService.setCheckoutMode(false);
                    // console.log('canceled edit payment options');
                  }
                );

                e.preventDefault();
              } // if _self.forceTransition
            } else if (toState.name === 'fulfillment') {
              // if toState.name === paymentOptions
              // @elseif
              // handle: navigate to techInstall from review

              // console.log('EDIT REVIEW');

              if (!_self.forceTransition) {
                var editTechInstallModalInstance = $modal.open({
                  templateUrl: 'modules/checkout/views/cancel-step-modal.html',
                  controller: 'CancelStepCtrl',
                  scope: $scope,
                  resolve: {
                    data: function() {
                      return {
                        isTechInstallTouched: $scope.forms.fulfillment.techInstallTouched,
                        toState: toState,
                        setForceTransition: function(boolValue) {
                          _self.forceTransition = boolValue;
                        },
                        getForceTransition: function() {
                          return _self.forceTransition;
                        }
                      };
                    }
                  }
                });

                editTechInstallModalInstance.result.then(
                  function(resp) {
                    if (_self.forceTransition) {
                      $state.go(resp.name);
                      _self.forceTransition = false;
                    }
                  },
                  function(respErr) {
                    buyService.setCheckoutMode(false);
                    // console.log('canceled edit tech b');
                  }
                );

                e.preventDefault();
              } // if _self.forceTransition
            } // elseif toState.name === fulfillment
          }
        } else if (
          toState.parent === 'fulfillment' &&
          fromState.parent === 'buy' &&
          !buyService.getSession('profile')
        ) {
          e.preventDefault();
        } else if (toState.parent === 'fulfillment' && fromState.name === 'review') {
          if (buyService.getSession('profile').fulfillment.techInstallTouched) {
            // @elseif
            // handle: navigate to techInstall from review

            // console.log('EDIT REVIEW');
            if (!_self.forceTransition) {
              var editTechInstallModalInstance = $modal.open({
                templateUrl: 'modules/checkout/views/cancel-step-modal.html',
                controller: 'CancelStepCtrl',
                scope: $scope,
                resolve: {
                  data: function() {
                    return {
                      isTechInstallTouched: $scope.forms.fulfillment.techInstallTouched,
                      toState: toState,
                      setForceTransition: function(boolValue) {
                        _self.forceTransition = boolValue;
                      },
                      getForceTransition: function() {
                        return _self.forceTransition;
                      }
                    };
                  }
                }
              });

              editTechInstallModalInstance.result.then(
                function(resp) {
                  if (_self.forceTransition) {
                    $state.go(resp.name);
                    _self.forceTransition = false;
                  }
                },
                function(respErr) {
                  buyService.setCheckoutMode(false);
                  // console.log('canceled edit tech b');
                }
              );

              e.preventDefault();
            } // if _self.forceTransition
          } // elseif toState.name === fulfillment
        } else if (
          toState.parent === 'fulfillment' &&
          fromState.parent === 'buy' &&
          buyService.getCheckoutMode() &&
          toState.name === 'techInstall'
        ) {
          if (!_self.forceTransition && fromState.name === 'review') {
            var editTechInstallModalInstance = $modal.open({
              templateUrl: 'modules/checkout/views/cancel-step-modal.html',
              controller: 'CancelStepCtrl',
              scope: $scope,
              resolve: {
                data: function() {
                  return {
                    isTechInstallTouched: $scope.forms.fulfillment.techInstallTouched,
                    toState: toState,
                    setForceTransition: function(boolValue) {
                      _self.forceTransition = boolValue;
                    },
                    getForceTransition: function() {
                      return _self.forceTransition;
                    }
                  };
                }
              }
            });

            editTechInstallModalInstance.result.then(
              function(resp) {
                if (_self.forceTransition) {
                  $state.go(resp.name);
                  _self.forceTransition = false;
                }
              },
              function(respErr) {
                buyService.setCheckoutMode(false);
                // console.log('canceled edit tech');
              }
            );

            e.preventDefault();
          } // if
        }
      });

      $scope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
        // console.log('@buy:STATE CHANGE ERROR', event, toState, toParams, fromState, fromParams, error);

        // TBD
        $rootScope.stateLoading = false;
      });

      $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams, error) {
        // console.log('@buy:STATE CHANGE SUCCESS');
        // console.log('$on.$stateChangeSuccess (toState)', toState);
        // console.log('$on.$stateChangeSuccess (fromState)',fromState);
        // console.log('$on.$stateChangeSuccess (toParams)', toParams);
        // console.log('$on.$stateChangeSuccess (fromParams)',fromParams);

        // TBD
        $rootScope.stateLoading = false;
      });

      $scope.$on('Events:Exit:Home', function(event, params) {
        var exitAppModalInstance;
        if (!_self.forceTransition && params.toPath) {
          exitAppModalInstance = $modal.open({
            templateUrl: 'modules/checkout/views/cancel-step-modal.html',
            controller: 'CancelStepCtrl',
            scope: $scope,
            resolve: {
              data: function() {
                return {
                  isTechInstallTouched: $scope.forms.fulfillment.techInstallTouched,
                  toState: params.toPath,
                  setForceTransition: function(boolValue) {
                    _self.forceTransition = boolValue;
                  },
                  getForceTransition: function() {
                    return _self.forceTransition;
                  }
                };
              }
            }
          });
        }

        if (exitAppModalInstance) {
          exitAppModalInstance.result.then(
            function(data) {
              if (_self.forceTransition) {
                /*
                 * @if
                 * handle: user click continue on modal
                 *
                 * @param data
                 * the state to be redirected to
                 *
                 */

                if ($state.current.name !== 'createUser' || $state.current.name !== 'creditCheck') {
                  /*
                   * @if
                   * set checkout mode = true
                   * but only if current state is not createUser or creditCheck
                   *
                   */

                  buyService.setCheckoutMode(true);
                }

                $window.location.replace(env.fidoHomePageUrl);

                // $state.go(data.name);
                _self.forceTransition = false;
              }
            },
            function(res) {}
          );
        }
      });

      // method to check rules and route the user to the appropriate sub route
      function route() {
        var incompletedStep = _.findKey($scope.forms, { __completed: false });

        if (incompletedStep) {
          // check if the fantastic 4 are not default
          if (
            ($rootScope.atg &&
              $rootScope.userPref &&
              !_.isEmpty($rootScope.atg) &&
              !_.isEmpty($rootScope.userPref) &&
              $rootScope.atg.userId.value === 'default') ||
            $rootScope.atg.hashKey.value === 'default' ||
            $rootScope.userPref.samKey === 'default' ||
            !$rootScope.atg.userId.value ||
            !$rootScope.atg.hashKey.value ||
            !$rootScope.userPref.samKey ||
            !commonService.customerHasWirelessService
          ) {
            // console.log('@buy:route(): IF', incompletedStep, $rootScope);

            /*
             * @if
             * handle: prereq before proceeding to checkout flow
             * if userId, hashKey, samKey is default
             * user will be redirected to home page
             *
             */

            if (!commonService.customerHasWirelessService) {
              $log.warn('UNKNOWN_USER_DETAILS');
              $timeout(function() {
                // TODO
                _satellite.setVar('error', 'FHSI | buy  failed');
                _satellite.track('bfa-fhsi-error');
                // notifier.notify.error();
              });

              // $state.go('cartSummary');
            } else if (
              $rootScope.atg.userId.value === 'default' ||
              $rootScope.atg.hashKey.value === 'default' ||
              $rootScope.userPref.samKey === 'default' ||
              !$rootScope.atg.userId.value ||
              !$rootScope.atg.hashKey.value ||
              !$rootScope.userPref.samKey
            ) {
              $log.warn('INVALID_ATG_VALUES');
              $timeout(function() {
                // TODO
                _satellite.setVar('error', 'FHSI | INVALID_ATG_VALUES');
                _satellite.track('bfa-fhsi-error');
                // notifier.notify.error();
              });
              // $state.go('cartSummary');
            } else {
              // $window.location.replace(env.fidoHomePageUrl);
            }

            // debug
            $state.go(incompletedStep, {});
            // end debug
          } else if (
            $scope.forms &&
            $scope.forms.creditCheck &&
            !$scope.forms.creditCheck.allowPAC &&
            $scope.forms.creditCheck.riskClassFlag
          ) {
            // console.log('@buy:route(): else if' );

            /*
             * @elseif
             * handle: CONDITIONAL_APPROVAL risk-class;
             * handle: page refresh event
             * while user haven't agreed to allow for PreAuth Option only and
             * while a riskClassFlag has a value
             * user will stay in credit-check or will be redirected to credit-check page in anycase
             *
             */

            $state.go('creditCheck');
          } else {
            // console.log('@buy:route(): else' );
            $state.go(incompletedStep, {});
          }
        } else if (buyService.getSession('confirmation')) {
          /*
           * @elseif
           * handle: confirmed order
           * handle: page refresh event
           *
           * user will be redirected to home page and
           * checkout session will be deleted
           *
           */

          $window.location.replace(env.fidoHomePageUrl);
          buyService.deleteCheckoutSession();
        }
      }
      console.log('>>>>>buy', $scope, $rootScope);
    }
  ]);
})();
